// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1SK3w","location":"Header_location__3P_LE"};